import { updateListingScore } from '@/utils/product/score';
import { replaceOperation } from '@/utils/product/operations';
import { editDescription } from '@/utils/edit/description';

import { ATTRIBUTE } from '@/constants/attributes';
import { EMPTY } from '@/constants';

export function description({ operation, product, ...rest }) {
  const value = operation.get('value');
  const updates = editDescription({ product, value });

  if (updates.product.hasIn(['score', ATTRIBUTE.DESCRIPTION])) {
    const { shop, userFeatures } = rest;
    updates.product = updateListingScore({ product: updates.product, shop, userFeatures });
  }

  return {
    ...rest,
    product: updates.product.set('operations',
      updates.operations.reduce(replaceOperation, updates.product.get('operations', EMPTY.LIST))
    ),
  };
}
